"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Label = exports.Error = exports.Checkbox = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _polished = require("polished");
var _styles = require("../../utils/styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Wrapper = _styledComponents.default.div`
  ${({
  $disabled
}) => (0, _styledComponents.css)`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: fit-content;

    ${$disabled && (0, _styledComponents.css)`
      opacity: 0.4;
      pointer-events: none;
    `}
  `}
`;
exports.Wrapper = Wrapper;
const Label = _styledComponents.default.label`
  ${({
  labelPlacement,
  theme
}) => (0, _styledComponents.css)`
    display: flex;
    align-items: center;
    gap: 0.6rem;
    color: ${theme.colors.primaryDark};
    font-size: ${theme.fonts.sizes.medium};

    ${labelPlacement === 'start' && (0, _styledComponents.css)`
      flex-direction: row-reverse;
    `}

    &:active input {
      box-shadow: 0px 0px 1px 1rem ${(0, _polished.opacify)(0.1, theme.colors.secondaryOpacity)};

      &:not(:checked) {
        background-color: ${(0, _polished.opacify)(0.1, theme.colors.secondaryOpacity)};
      }
    }
  `}
`;
exports.Label = Label;
const Checkbox = _styledComponents.default.input.attrs({
  type: 'checkbox'
})`
  ${({
  theme
}) => (0, _styledComponents.css)`
    align-self: flex-start;
    border-radius: ${theme.border.radius.small};
    border: 2.5px solid ${theme.colors.secondary};
    color: ${theme.colors.white};
    cursor: pointer;
    font-family: ${theme.fonts.family.fontAwesome};
    margin: 1rem;
    min-height: 2.2rem;
    min-width: 2.2rem;

    ${_styles.appearanceNone}

    &:hover {
      box-shadow: 0px 0px 1px 1rem ${(0, _polished.opacify)(0.05, theme.colors.secondaryOpacity)};

      &:not(:checked) {
        background-color: ${(0, _polished.opacify)(0.05, theme.colors.secondaryOpacity)};
      }
    }

    &:checked {
      background-color: ${theme.colors.secondary};
      position: relative;

      &::before {
        content: '\\f00c';
        display: flex;
        font-size: 1.9rem;
        line-height: 0.9;
        margin: auto;
        width: fit-content;
      }
    }
  `}
`;
exports.Checkbox = Checkbox;
const Error = _styledComponents.default.p`
  ${({
  theme
}) => (0, _styledComponents.css)`
    color: ${theme.colors.error};
    font-size: ${theme.fonts.sizes.small};
    line-height: 1.2;
  `}
`;
exports.Error = Error;